
<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import "lodash";
import { BaseAtom } from "components/cards/atoms";
import { PlaylistParticle } from "components/cards/particles/YinzCam/Media/Playlist";
export let container;
export let playlist;
</script>

<style></style>

<BaseAtom _isotope="PlaylistAtom" {...container}>
  <PlaylistParticle {...playlist}/>
</BaseAtom>